/**
 * 语言管理工具
 * 提供语言切换和翻译功能
 */

import { getCurrentLanguage, setLanguage, languageTexts, LANGUAGES } from '../config/languageConfig';

class LanguageManager {
  constructor() {
    this.currentLanguage = getCurrentLanguage();
    this.listeners = new Set();
    
    // 监听语言变更事件
    if (typeof window !== 'undefined') {
      window.addEventListener('languageChanged', this.handleLanguageChange.bind(this));
    }
  }

  /**
   * 处理语言变更事件
   */
  handleLanguageChange(event) {
    const { language } = event.detail || {};
    this.currentLanguage = language || getCurrentLanguage();
    
    // 通知所有监听器
    this.listeners.forEach(listener => {
      try {
        listener(this.currentLanguage);
      } catch (error) {
        console.error('[LanguageManager] 监听器执行失败:', error);
      }
    });
  }

  /**
   * 获取当前语言
   */
  getCurrentLanguage() {
    return this.currentLanguage;
  }

  /**
   * 切换语言
   */
  switchLanguage(language) {
    if (![LANGUAGES.ZH, LANGUAGES.EN].includes(language)) {
      console.error('[LanguageManager] 不支持的语言:', language);
      return false;
    }
    
    this.currentLanguage = language;
    setLanguage(language);
    return true;
  }

  /**
   * 切换语言（交替切换）
   */
  toggleLanguage() {
    const newLanguage = this.currentLanguage === LANGUAGES.ZH ? LANGUAGES.EN : LANGUAGES.ZH;
    return this.switchLanguage(newLanguage);
  }

  /**
   * 获取翻译文本
   * @param {string} key - 翻译键，支持点分隔的嵌套键
   * @param {*} defaultValue - 默认值
   * @returns {string} 翻译后的文本
   */
  t(key, defaultValue = null) {
    const keys = key.split('.');
    let text = languageTexts[this.currentLanguage];
    
    for (const k of keys) {
      if (text && typeof text === 'object') {
        text = text[k];
      } else {
        // 如果找不到翻译，返回默认值或key本身
        return defaultValue !== null ? defaultValue : key;
      }
    }
    
    return text || defaultValue || key;
  }

  /**
   * 注册语言变更监听器
   */
  addListener(listener) {
    this.listeners.add(listener);
    
    // 返回取消监听的函数
    return () => {
      this.listeners.delete(listener);
    };
  }

  /**
   * 移除监听器
   */
  removeListener(listener) {
    this.listeners.delete(listener);
  }
}

// 导出单例
const languageManager = new LanguageManager();

export default languageManager;


